import axios from "axios";

/**
 * 
 * @param {*} endpoint 
 * @param {*} token 
 * @param {*} params 
 * @returns {{ status: { code: Integer, response: String }, pagination: {}, token: String, params: {}, data: {} }}
 */
export async function axiosGet(endpoint, token, params = {}) {
  const apiConfig = {
    method: "GET",
    baseURL: process.env.REACT_APP_API_URL,
    mode: "cors",
    url: endpoint,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token
    },
    params
  };

  try {
    const response = await axios(apiConfig);
    return response.data;
  } catch (error) {
    if (!error.response) return null;
    const errorResponse = error.response
    if (errorResponse.status && errorResponse.status === 401) {
    }
    return errorResponse.data
  }
};

/**
 * 
 * @param {String} endpoint 
 * @param {String} token 
 * @param {{}} data 
 * @param {{}} extraHeaders 
 * @returns {{ status: { code: Integer, response: String }, pagination: {}, token: String, params: {}, data: {} }}
 */
export async function axiosPost(endpoint, token, data, axiosOptions = {}) {
  const apiConfig = {
    method: "POST",
    baseURL: process.env.REACT_APP_API_URL,
    mode: "cors",
    url: endpoint,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token
    },
    data,
    ...axiosOptions 
  };

  const isEmptyObject =
    data !== null &&
    data !== undefined &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    Object.keys(data).length === 0;

  if (data === null || data === undefined || isEmptyObject) {
    delete apiConfig.data
  }

  try {
    const response = await axios(apiConfig);
    return response.data;
  } catch (error) {
    if (!error.response) return null;
    const errorResponse = error.response
    if (errorResponse.status && errorResponse.status === 401) {
      return 401
    }
    return errorResponse.data
  }
};

/**
 * 
 * @param {String} endpoint 
 * @param {String} token 
 * @param {FormData} data 
 * @returns 
 */
export async function axiosMultipart(endpoint, token, data = {}, axiosOptions = {}) {
  const apiConfig = {
    method: "POST",
    baseURL: process.env.REACT_APP_API_URL,
    mode: "cors",
    url: endpoint,
    timeout: 60000,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: token,
    },
    data,
    ...axiosOptions 
  };

  try {
    const response = await axios(apiConfig);
    return response.data;
  } catch (error) {
    const errorResponse = error.response
    if (errorResponse.status && errorResponse.status === 401) {
    }
    return errorResponse.data
  }
};